export const intakeConstants = {
  INTAKE_SEARCH_REQUEST: 'INTAKE_SEARCH_REQUEST',
  INTAKE_SEARCH_SUCCESS: 'INTAKE_SEARCH_SUCCESS'
}